module.exports = __webpack_public_path__ + "static/media/ques.994849ba.gif";